import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { ReframeSection } from '../components/ReframeSection';
import { ProductSection } from '../components/ProductSection';
import { ResultsSection } from '../components/ResultsSection';
import { TargetSection } from '../components/TargetSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingSection } from '../components/PricingSection';
export function SalesPage() {
  return <main className="min-h-screen bg-cream-100 font-sans text-brown selection:bg-terracotta/20" data-id="element-134">
      <Hero data-id="element-135" />
      <ProblemSection data-id="element-136" />
      <ReframeSection data-id="element-137" />
      <ProductSection data-id="element-138" />
      <ResultsSection data-id="element-139" />
      <TargetSection data-id="element-140" />
      <BenefitsSection data-id="element-141" />
      <PricingSection data-id="element-142" />

      <footer className="py-8 text-center text-brown-light/60 text-sm bg-cream-200" data-id="element-143">
        <p data-id="element-144">
          © {new Date().getFullYear()} Reset de Hinchazón. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}